import { SebraeCarro } from '@/models/sebraeCarro'
import { SebraeCarroAPI } from '@/api/sebraeCarro.api'
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface'

const sebraeCarroApi = new SebraeCarroAPI()

const findBy = (placa: string, recaptcha: string): AxiosObservable<SebraeCarro> => {
  return sebraeCarroApi.findBy(placa, recaptcha)
}

export default { findBy }
